import request from '@/utils/request'

// 查询回款记录列表
export function listReceivable(query) {
  return request({
    url: '/fina/receivable/list',
    method: 'get',
    params: query
  })
}

// 查询回款记录详细
export function getReceivable(receivableId) {
  return request({
    url: '/fina/receivable/' + receivableId,
    method: 'get'
  })
}

// 新增回款记录
export function addReceivable(data) {
  return request({
    url: '/fina/receivable',
    method: 'post',
    data: data
  })
}

// 修改回款记录
export function updateReceivable(data) {
  return request({
    url: '/fina/receivable',
    method: 'put',
    data: data
  })
}

// 删除回款记录
export function delReceivable(receivableId) {
  return request({
    url: '/fina/receivable/' + receivableId,
    method: 'delete'
  })
}

// 导出回款记录
export function exportReceivable(query) {
  return request({
    url: '/fina/receivable/export',
    method: 'get',
    params: query
  })
}